import { APICfg } from 'services/api/api'
import { APIFood } from '../food/types/api/response-models'
import { ProductSectionWithDescription } from '../types'
import { productSectionParse } from '../utils'

type FoodSection = ProductSectionWithDescription<APIFood>

type FoodSectionToAPI = FoodSection

const apiCfg: APICfg = {
  endpoint: 'foodsections',
  parse: productSectionParse,
  write: async (req: FoodSection): Promise<FoodSectionToAPI> => req,
}
export default apiCfg
